<template>
  <div class="login-container">

    <div class="left-section">

      <div class="domain-info">
        <a href="#" class="logo">
          <img :src="defaultLogo" alt="Sign Up Banner" />
        </a>
        <p class="mb-1 available text-uppercase" style="letter-spacing: 4px; font-size: 14px">
          Welcome to
        </p>
        <p class="available mb-1 ">
          <span> Your Digital Transformation Partner </span>
          <!---->
        </p>
        <h1 class="site-title">
          KodeFast <span class="strike-animate">Low</span> <i class="animate-no">No</i> Code Platform
          <!-- KodeFast <del class="animate-low">Low</del> <i class="animate-no">No</i> Code Platform -->
        </h1>
        <!---->
        <div class="layout justify-center row wrap"></div>
        <div class="legal mt-3 pb-3 hidden-sm-and-down">
          <p class="mb-1">
            Transform your business with powerful workflows, seamless automations, and innovative tools—all without the
            need for any coding! <br /> Let's unlock your potential together!
          </p>
        </div>
      </div>
    </div>
    <div class="right-section">
        <router-view />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import WhiteLabelConfig from "../../config/app";
import DefaultSEOData from  "../../config/seo";
export default {
  name: "SignIn",
  data() {
    return {
      pageData: {
        title: '',
        description: '',
        keywords: '',
        image: '',
        favicon: ''
      },
      defaultLogo: "../../assets/logo.webp",
      currentForm: 'default',
      isResent: false,
      submitLoading: false,
      passwordType: "password",
      signin: {
        email: "",
        phone: "",
        password: "",
        remember_me: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "Email is required",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Invalid Email",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "blur",
          },
        ],
      },
      isExist: false,
      userWorkspaceList: [],
      currentWorkspace: {},
      applicationSettings: {},
      centerDialogVisible: false,
      syncLoadingText: "Please wait, we are setting things up for you...",
    };

  },
  metaInfo() {
    const meta = { ...DefaultSEOData, ...this.pageData }
    return {
      title: meta.title ,
      meta: [
        { name: 'description', content: meta.description  },
        { name: 'keywords', content: meta.keywords},
        { name: 'robots', content: 'index,follow' },

        // OpenGraph Tags
        { property: 'og:title', content:meta.title },
        { property: 'og:description', content: meta.description },
        { property: 'og:image', content: meta.image },
        { property: 'og:type', content: 'website' },

        // Twitter Tags
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: meta.title  },
        { name: 'twitter:description', content: meta.description },
        { name: 'twitter:image', content: meta.image }
      ],
      link: [
        // Favicon Variants
        { rel: 'icon', type: 'image/x-icon', href: meta.favicon },
        { rel: 'icon', type: 'image/png', href: '/favicon.png' },
        { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
        { rel: 'apple-touch-icon', href: '/apple-touch-icon.png' }
      ]
    }
  },
  mounted() {
    this.$store.dispatch("auth/reset");
    this.$store.commit("company/resetCompaniesByEmail");
    this.applicationSettings = WhiteLabelConfig;
    // fetchAndAddIconsToLocal();
  },
  computed: {
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("company", ["getCompaniesByEmail"]),
    ...mapGetters("auth", [
      "getErrorMessage",
      "getOtpVerifiedStatus",
      "getAuthenticationStatus",
      "getAccountNotVerified",
      "getAccountNotVerifiedEmail",
      "getWorkspaceList",
      "getAuthenticatedUser",
      "getUserType",
      "getErrorCode",
      "getErrorData",
      "getResendVerificationEmail",
      "getMf2a",
    ]),
    logoUrl() {
      return "../../" + this.applicationSettings.LOGO;
    },
    getNewStyles() {
      return `background-color: #${this.applicationSettings.PRIMARY_COLOR}; background-image: linear-gradient(to bottom right,#${this.applicationSettings.PRIMARY_COLOR}, #${this.applicationSettings.SECONDARY_COLOR});`;
    },

    getButtonStyles() {
      return `background-color:#${this.applicationSettings.SECONDARY_COLOR}; background-image: linear-gradient(-240deg,#${this.applicationSettings.PRIMARY_COLOR}, #${this.applicationSettings.SECONDARY_COLOR});color:#FFFFFF;`;
    },
    getPrimaryColor() {
      return `color:#${this.applicationSettings.PRIMARY_COLOR} !important;`;
    },
  },
  created() {
    this.$store.commit("errors/setErrors", null, { root: true });
    setTimeout(() => {
      this.pageData = {
        title: 'Kodefast No code platform ',
        description: 'Start building your automation today.',
        keywords: 'kodefast, onboarding, automation',
        image: 'https://esigns.io/images/logo-dark.png',
        favicon: ''
      }
    }, 1000);
  },
  methods: {

  },
};
</script>


<style lang="scss" scoped>

.swal2-icon {
  .swal2-info {
    border-color: #f754a2 !important;
    color: #f754a2 !important;
  }
}

.swal2-styled {
  .swal2-confirm {
    background-color: #f754a2 !important;
  }
}



a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  /* Optional: underline on hover */
  color: #196392 !important;
}

/* Style for the links */
.forgot-password-link {
  font-size: 14px;
  color: #409eff;
  text-decoration: none;
  font-weight: bold;
}

.forgot-password-link:hover {
  text-decoration: underline;
}

/* Divider with lines and 'OR' in the middle */
.divider {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  /* margin: 0 20px; */
}

.line {
  flex: 1;
  border-top: 1px solid #ddd;
  /* light gray line */
}

.divider-text {
  margin: 0 10px;
  color: #aaa;
  font-size: 16px;
  font-weight: bold;
}

/* Flex container for title and link */
.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.login-title {
  font-size: 24px;
  margin: 0;
}

.forgot-password-link {
  font-size: 14px;
  color: #409eff;
  /* Light blue color for the link */
  text-decoration: none;
}

.forgot-password-link:hover {
  text-decoration: underline;
}

.forgot-login-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.forgot-password-link {
  font-size: 14px;
  color: #409eff;
  text-decoration: none;
  cursor: pointer;
  margin: 4px 0;
}

.login-button {
  padding: 6px 16px;
  font-size: 14px;
  border-radius: 4px;
  min-width: 90px;
}

.center-link {
  /* width: 100%; */
  text-align: center;
}

.logo {
  img {
    width: 14em;
    margin-bottom: 27%;

    @media (max-width: 1024px) {
      width: 14em;
      margin-bottom: 15%;
    }

    @media (max-width: 480px) {
      width: 10em;
      margin-bottom: 10%;
    }
  }
}

.password-input-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  user-select: none;
}

.forgot-password-row {
  text-align: right;
  margin-top: -10px;
}

.forgot-password-link {
  color: #409eff;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.login-container {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  background-image: url("https://image.bodiscdn.com/parking/landing-hero.png");
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.left-section {
  flex: 1;
  display: flex;

  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;
}

.right-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;
}

.branding {
  max-width: 400px;
  text-align: left;
  color: #fff;
}

.branding h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.branding p {
  font-size: 1.2rem;
}

.login-form {
  border: 1px solid #cfcfcf;
  border-radius: 2em;

  width: 100%;
  max-width: 550px;
  padding: 2rem;
  /* border-radius: 8px; */
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.login-form h2 {
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.login-form button {
  padding: 0.75rem;
  background-color: #0066cc;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}

.login-form button:hover {
  background-color: #005bb5;
}

.domain-info {
  max-width: 476px;
  margin-right: 120px;
}

.domain-info h1 {
  color: #196392;
  font-size: 33px;
  font-weight: 700;
  line-height: 1.3;
}

.domain-info .available {
  font-size: 18px;
  color: #0a0a0a;
  font-weight: 600;
}

.domain-info .v-btn {
  font-size: 24px;
  font-weight: bold;
  padding: 25px 40px;
  margin-left: 0px;
  margin-right: 0px;
}

.legal {
  font-size: 14px;
  line-height: 16px;
  color: #0a0a0a;
  max-width: 630px;
}

.strike-animate {
  position: relative;
  color: red;
}

.strike-animate::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  height: 2px;
  background: red;
  width: 0;
  transform: translateY(-50%);
  animation: strikeLine 2s ease-in-out forwards;
}

/* Animate the "No" word */
.animate-no {
  display: inline-block;
  animation: bounceIn 2s ease-in-out infinite alternate;
  color: #007bff;
}

@keyframes strikeLine {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

@keyframes bounceIn {
  from {
    transform: scale(1);
    opacity: 0.8;
  }

  to {
    transform: scale(1.1);
    opacity: 1;
  }
}

/* FULL RESPONSIVE FOR MOBILE & TABLET */
@media (max-width: 1024px) {
  .login-container {
    flex-direction: column;
    padding: 1rem;
    background-position: top center;
  }

  .left-section {
    width: 100%;
    padding: 1rem;
    text-align: center;
  }

  .right-section {
    width: 100%;
    padding: 1rem;
  }

  .branding {
    max-width: 100%;
    color: #fff;
  }

  .branding h1 {
    font-size: 2rem;
  }

  .branding p {
    font-size: 1rem;
  }

  .domain-info {
    margin: 0 auto;
    max-width: 100%;
  }

  .domain-info h1 {
    font-size: 24px;
  }

  .domain-info .available {
    font-size: 16px;
  }

  .domain-info .v-btn {
    font-size: 18px;
    padding: 15px 25px;
  }

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    max-width: 100%;
    padding: 1.5rem;
    margin: 0 auto;
    box-shadow: none;
    /* border-radius: 0; */
  }

  .login-form h2 {
    font-size: 1.5rem;
  }

  .password-toggle {
    right: 10px;
    font-size: 12px;
  }
}

h1,
p {
  margin-bottom: 0.5rem !important;
}

hr {
  margin: 0.5rem 0 !important;
}

.signup-wrapper {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
}

.el-form-item {
  margin-bottom: 8px !important;
}

h1,
p,
hr {
  margin-top: 0 !important;
  margin-bottom: 0.5rem !important;
}

.password-input-wrapper {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
  user-select: none;
}

.name-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 768px) {
  .name-fields {
    flex-direction: row;
  }

  .name-fields .el-form-item {
    flex: 1;
  }

  .name-fields .el-form-item:first-child {
    margin-right: 10px;
  }
}

.terms-wrap {
  display: inline-block;
  white-space: normal;
  word-break: break-word;
  max-width: 100%;
}

.d-flex {
  display: flex;
}
.justify-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.flex-wrap {
  flex-wrap: wrap;
}
.mb-3 {
  margin-bottom: 1rem; /* adjust as needed */
}
.m-0 {
  margin: 0;
}
.register-heading {
  font-size: 1.25rem; /* Larger text, you can go up to 1.5rem if needed */
  font-weight: 600;   /* Semi-bold */
    color: #196392;   /* Bootstrap's text-dark */
  padding-bottom: 0.5rem;
  margin: 0;
  display: inline-block;
}

</style>
